import * as React from 'react'
import { DateRangePicker } from 'rsuite'
import {
    TextFieldSeeker,
    IconSeekers,
    DateRangePickerSeeker,
    ModalSeeker,
    RadioGroupSeeker,
    DatePickerSeeker,
    GridSeeker,
} from "ui-seeker/core"

const radioGroupData = [{
    value: "1Day",
    label: "1 day"
}, {
    value: "moreThanOneDay",
    label: "More than one day"
}]

const sliderMarks = [{
    value: '1',
    label: 'Low',
}, {
    value: '2',
    label: 'Medium',
}, {
    value: '3',
    label: 'High',
}]

const { beforeToday } = DateRangePicker

function TitleModal() {
    return <span>
        <IconSeekers icon="calendar-check" iconType="fontAwesome"/>
        Add event
    </span>
}

export default function AppCreateEventModal({ isOpen, controller, onSubmit, updateState, formData, isLoading }) {
    const { dateRange, title, description, dateType, datePicker, relevance } = formData

    return <ModalSeeker
        isOpen={isOpen}
        controller={() => controller()}
        title={<TitleModal />}
        size='xs'
        okClassName='bg-primary-top'
        onSuccess={() => {
            onSubmit()
        }}
        onCancel={() => {
            controller()
        }}
        isLoading={isLoading}
        backdropClassName='daily-price-event'
    >
        <GridSeeker container>
            <GridSeeker size={12} className="event-name">
                <TextFieldSeeker id="title" value={title} label="Name" variant="standard" onChange={e => updateState({ title: e.target.value })} />
            </GridSeeker>
            <GridSeeker size={12} className="event-description">
                <TextFieldSeeker id="description" value={description} label="Description" variant="standard" onChange={e => updateState({ description: e.target.value })} />
            </GridSeeker>

            <GridSeeker size={12} className="date-type">
                <RadioGroupSeeker dataRadioGroup={radioGroupData} formLabel="Date" defaultValue={dateType} onChange={e => updateState({ dateType: e.target.value, datePicker: null, dateRange: [] })} />
            </GridSeeker>

            <GridSeeker size={12} className="selector-date">
                {dateType === '1Day' && <DatePickerSeeker id="datePicker" value={datePicker} onChange={(e) => updateState({ datePicker: e })} />}
                {dateType === 'moreThanOneDay' && <DateRangePickerSeeker
                    id="dateRange"
                    value={dateRange}
                    onChange={(e) => updateState({ dateRange: e })}
                    disabledDate={d => beforeToday()(d)}
                />}
            </GridSeeker>

            <GridSeeker size={12} className="date-type">
                <RadioGroupSeeker dataRadioGroup={sliderMarks} formLabel="Relevance" defaultValue={relevance.toString()} onChange={e => updateState({ relevance: e.target.value })} />
            </GridSeeker>
        </GridSeeker>
    </ModalSeeker>
}
